import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography, IconButton, Box, Badge } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface HeaderProps {
  showBackButton?: boolean;
  title?: string;
}

const Header: React.FC<HeaderProps> = ({ showBackButton = false, title }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isOnHome = location.pathname === '/home';
  
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <AppBar 
      position="sticky" 
      color="inherit" 
      sx={{ 
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Toolbar sx={{ minHeight: '56px !important', px: 2 }}>
        {showBackButton ? (
          <IconButton 
            edge="start" 
            onClick={handleBack}
            sx={{ mr: 1 }}
          >
            <ArrowBackIcon />
          </IconButton>
        ) : (
          <Box sx={{ width: 40 }} />
        )}
        
        <Typography 
          variant="h6" 
          component="div" 
          sx={{ 
            flexGrow: 1, 
            fontWeight: 800,
            color: 'primary.main',
            letterSpacing: '-0.02em',
          }}
        >
          {title || 'YardApp'}
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <IconButton>
            <MenuIcon />
          </IconButton>
          <IconButton>
            <Badge 
              badgeContent={0} 
              color="error"
              sx={{ 
                '& .MuiBadge-badge': { 
                  fontSize: '0.65rem',
                  minWidth: '16px',
                  height: '16px',
                } 
              }}
            >
              <NotificationsNoneIcon />
            </Badge>
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
